'use client';

import { cn, Div } from '@scatterlab/zeta-core';
import { FC, memo, MouseEvent, ReactNode, useCallback } from 'react';

import { BUBBLE_THEME_CLASS_NAMES, BubbleTheme } from './bubble-theme';

export type ChatBubbleContainerProps = {
  className?: string;
  translucent?: boolean;
  loading?: boolean;
  mine?: boolean;
  children?: ReactNode;
  onPress?: () => void;
  onLongPress?: () => void;
  rounded?: boolean;
  theme?: BubbleTheme;
};

const ChatBubbleContainer: FC<ChatBubbleContainerProps> = ({
  className,
  translucent,
  loading,
  mine,
  children,
  onPress,
  onLongPress,
  rounded,
  theme = BubbleTheme.DEFAULT,
}) => {
  const handleContextMenu = useCallback(
    (e: MouseEvent<HTMLDivElement>) => {
      if (onLongPress) {
        e.preventDefault();
        onLongPress();
      }
    },
    [onLongPress],
  );

  return (
    <Div
      className={cn(
        'native:shrink flex w-fit flex-col',
        !loading && 'px-3 py-2',
        {
          'self-end rounded-l-xl rounded-br-xl': mine,
          'self-start rounded-r-xl rounded-bl-xl': !mine,
          'rounded-xl': rounded,
        },
        !mine && BUBBLE_THEME_CLASS_NAMES[theme].character.bg,
        mine &&
          translucent &&
          BUBBLE_THEME_CLASS_NAMES[theme].mine.translucentBg,
        mine && !translucent && BUBBLE_THEME_CLASS_NAMES[theme].mine.bg,
        className,
      )}
      onTouchStart={(e) => e.stopPropagation()}
      onPress={onPress}
      onLongPress={onLongPress}
      onContextMenu={handleContextMenu}
    >
      {children}
    </Div>
  );
};
export default memo(ChatBubbleContainer);
